import React from "react";
import Lottie from "react-lottie";
import "./UploadFile_Lottie.css";
import * as animationData from "./UploadFile_Lottie.json";

function UploadFile_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="UploadFile_Lottie_icon">
        <Lottie
          className="me-auto"
          options={defaultOptions}
          // height={60}
          // width={60}
        />
      </div>
    </section>
  );
}
export default UploadFile_Lottie;
